module.exports = __webpack_public_path__ + "media/images/page/lp-sample_large-b4fdf3c2cdd6ea835a624c60c458a0f4.jpg";